export default __webpack_public_path__ + "static/media/me.0c22dbf3.svg";